import { variationKeyEnum } from '../enum/experimentKey'

export const WIX_DOMAINS_SEARCH_CTA_NAV_EXPERIMENT_LOCALES = ['en-US', 'en-CA', 'en-GB']
export const WIX_DOMAINS_UPSELL_PAGE_EXPERIMENT_LOCALES = ['en-US', 'en-CA', 'en-GB']
export const WIX_DOMAINS_SEARCH_PAGE_PRICING_EXPERIMENT_LOCALES = ['en-US', 'es-US']
export const WIX_DOMAINS_SEARCH_PAGE_PRICING_EXPERIMENT_VARIATIONS = [
  variationKeyEnum.WIX_DOMAINS_SEARCH_PRICING_CONTROL_VARIATION,
  variationKeyEnum.WIX_DOMAINS_SEARCH_PRICING_TEST_VARIATION,
]
export const CTA_EXPERIMENT_VARIATION_WITHOUT_UPSELL = 'without_domains_upsell'
export const WIX_DOMAINS_DYNAMIC_UI_ROLLOUT_LOCALES = ['en-US']

export const SOCIAL_MEDIA_RESPONSE_STATUS_SUCCESS = 'SUCCESS'
